import { request } from '../../../utils/request';

export default async function verifyIndividualAddress(
  formData: { address_id: number; meter_number: string; disco_code: string },
  authToken: string
): Promise<{
  success: boolean;
  message: string;
}> {
  const res = await request({
    url: '/sterling/kyc/addresses/verify',
    method: 'POST',
    formData,
    headers: { Authorization: `Bearer ${authToken}` },
  });

  if (!res.success) throw new Error(res.message);
  return res;
}
